import * as THREE from 'three'
import { Object3D } from 'three'
export default class MovableObject extends Object3D {

    constructor(controls) {
        super()
        this.controls = controls

        this.addBindings()
        this.addEventListeners()
    }

    addBindings() {
        this.onClick = this.onClick.bind(this)
        this.onClickEnd = this.onClickEnd.bind(this)
        this.handleMove = this.handleMove.bind(this)
    }

    addEventListeners() {
        this.controls.addEventListener('selectStart', this.onClick)
        this.controls.addEventListener('selectEnd', this.onClickEnd)
        this.controls.addEventListener('rayMove', this.handleMove)
    }

    removeEventListeners() {
        this.controls.removeEventListener('selectStart', this.onClick)
        this.controls.removeEventListener('selectEnd', this.onClickEnd)
        this.controls.removeEventListener('rayMove', this.handleMove)
    }

    onClick(event) {
        const evt = event.data
        const intersecting = this.checkForIntersects(evt)
        if (intersecting) {
            this.grabDistance = intersecting.distance
            this.moving = intersecting.distance ? true : false
            const existingObject = this.controls.intersectableObjects.find(v => v.uuid === intersecting.object.uuid)
            console.log(intersecting.object)
            if (!existingObject) this.controls.intersectableObjects = [...this.controls.intersectableObjects, intersecting.object]
        }
    }

    onClickEnd(evt) {
        this.moving = false
    }


    handleMove(evt) {
        try {
            if (!this.moving) return
            const raycaster = evt.data.raycaster
            if (!raycaster) return
            this.lookAt(raycaster.ray.origin)

            const grabPoint = new THREE.Vector3()
            const grabOriginPosition = raycaster.ray.origin
            const direction = this.controls.raycaster.ray.direction
            // const params = this.children[0].geometry.parameters
            // const depth = params.depth

            direction.normalize()
            grabPoint.addVectors(grabOriginPosition, direction.multiplyScalar(this.grabDistance || 1))
            // grabPoint.addVectors(grabPoint, new THREE.Vector3(0, 0, -depth / 2))

            const newPosition = grabPoint
            this.position.set(newPosition.x, newPosition.y, newPosition.z)
        } catch (e) {
            console.log(e)
        }
    }


    checkForIntersects(evt) {
        if (evt && evt.raycaster) {
            const raycaster = evt.raycaster
            const intersect = raycaster.intersectObject(this, true)
            if (intersect.length > 0) {
                return intersect[0]
            } else return false
        }
        else return false
    }
}